import * as React                       from "react";
import {Redirect}                       from "react-router-dom";
import                                       "./office-address-lists-route.scss"
import {cs}                             from "@Common/react/chain-services";
import {consumeContext}                 from "@Common/react/context";
import {Invoke}                         from "@Common/react/invoke";
import {parseUrlQuery}                  from "@Common/utils/parse-url-query";
import {MailingListsPanel}              from "@Xpresso/routes/account/common/mailing-lists-panel/mailing-lists-panel";
import {OfficeAdminLayout}              from "../common/office-admin-layout";
import {Context}                        from "../common/office-admin-layout-loader";

export const OfficeAddressListsRoute = () => cs(
    consumeContext("routerHistory"),
    ["officeId", ({}, next) => next(
        parseUrlQuery(window.location.search)?.office || parseUrlQuery(window.location.search)?.branch
    )],
    ({officeId}, next) => (
        !officeId ? (
            <Redirect to="/account/admin/office"/>
        ) : (
            next()
        )
    ),
    ["loader", (_, next) => (
        <Context.Consumer>
            {next}
        </Context.Consumer>
    )],
    ["data", ({loader, officeId}, next) => loader.loadData({officeId, next})],
    ({data, routerHistory}, next) => (
        (data.loading || data?.office?.idBranch) ? (
            next()
        ) : (
            Invoke({action: () => {
                data.clear();
                routerHistory.replace("/account/admin/office");
            }})
        )
    ),
    ["office", ({data}, next) => next(data.office)],
    ({office, officeId, data}, next) => OfficeAdminLayout({activeTab: "office-address-lists", office, officeId, reload: data.reload, next}),
    ({}, next) =>
        <div className="office-address-lists-CH3COOH">
            {next()}
        </div>,
    ({officeId}) => MailingListsPanel({entityId: officeId}),
)